import React from "react";

import { Box, Typography } from '@mui/material';

import theme_ from "theme/CurrentTheme";


interface Props {
    title?: string;
}

export default function PageFooter(props: Props) {
    return <Box display='flex' alignItems='center' justifyContent='center' sx={{
        // position: 'absolute',
        // bottom: 0,
        // left: 0,
        // right: 0,
        height: theme_.pageFooterHeight,
        // m: 0,
        // p: 0,
    }}>
        <Typography sx={{
            fontSize: theme_.pageFooterFontSize,
        }}>Copyright (C) 2006-2022 Andrei Mirzoyan</Typography>
    </Box>
}

